/** Максимальное количество опций когда будет отображаться сокращенный вариант модалки в мобильной версии  */
export const MAX_CHILDREN_FOR_SHORT_MODE = 10;
